// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-8ef0e6ae]:root{--light_text_color:#666}.footer__settings[data-v-8ef0e6ae]{display:flex;align-items:center;justify-content:center}.footer__settings--flex-start[data-v-8ef0e6ae]{justify-content:flex-start}.footer__settings--currency-switcher[data-v-8ef0e6ae]{display:inline-block;margin-right:5px}.footer__settings--currency-switcher select[data-v-8ef0e6ae]{width:200px;margin-bottom:18px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
